import { Injectable } from '@angular/core';
import { BehaviorSubject, mergeMap, Subject, Subscription, tap } from "rxjs";
import { environment } from "../../../environments/environment";
import { webSocket, WebSocketSubject } from "rxjs/webSocket";

@Injectable({
  providedIn: 'root',
})
export class NotificationService {

  public connect(jobId: string): WebSocketSubject<unknown> {

    console.log(`%c${new Date().toISOString().substring(11, 19)} %cWebSocket connection triggered - opening new connection for job %c${jobId}`, "color: red", "color: green", "color: magenta")

    return webSocket({
      url: environment.ws_url + '?jobId=' + jobId,
      closeObserver: {
        next: (e: CloseEvent) => {
          console.log(`%c${ new Date().toISOString().substring(11, 19) } %cWebSocket connection closed for job %c${jobId}`, "color: red", "color: green", "color: magenta");
        }
      },
      openObserver: {
        next: (e: Event) => {
          console.log(`%c${ new Date().toISOString().substring(11, 19) } %cWebSocket connection opened for job %c${jobId}`, "color: red", "color: green", "color: magenta");
        }
      }
    });
  }
}
